/* ─────────────────────────────────────────────────────────────────────────
   reportHelpers — small pure helpers over the ReportPayload contract.
─────────────────────────────────────────────────────────────────────────── */
import type { ReportPayload, SectionKey } from "../types/reportTypes";

/* Convenience: is a section enabled for the active role? */
export const isVisible = (p: ReportPayload, key: SectionKey): boolean =>
  p.visibleSections.includes(key);

/* Compliance bar colour bucket (mirrors the backend thresholds). */
export const complianceClass = (pct: number): "green" | "amber" | "red" =>
  pct >= 80 ? "green" : pct >= 50 ? "amber" : "red";
